import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { openConfirmationDialog, closeConfirmationDialog } from 'redux/actions/confirmation-dialogs';
import { isConfirmationDialogShown } from 'redux/selectors/confirmation-dialogs';
import { useAppDispatch } from 'redux/store';
import t from 'react-translate';

const useDiscardMentorMessage = () => {
  const dispatch = useAppDispatch();
  const isDialogShown = useSelector(isConfirmationDialogShown);
  const translationBase = (
    t.MENTORING_PROGRAMS.PARTICIPANT_HOME.MENTOR_REQUEST_MODAL.MENTEE_VIEW.DISCARD_CHANGES
  );

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (isDialogShown && event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        dispatch(closeConfirmationDialog());
      }
    };

    if (isDialogShown) {
      window.addEventListener('keydown', handleEsc);
    }

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isDialogShown, dispatch]);

  const openDiscardChangesDialog = useCallback((onConfirm: () => void) => {
    dispatch(
      openConfirmationDialog({
        title: translationBase.TITLE(),
        bodyText: translationBase.BODY(),
        confirmText: translationBase.DISCARD(),
        cancelText: translationBase.CANCEL(),
        onConfirm: () => {
          dispatch(closeConfirmationDialog());
          onConfirm();
        },
      }),
    );
  }, [dispatch]);

  return openDiscardChangesDialog;
};

export default useDiscardMentorMessage;